import { useEffect } from "react";

import ServiceCardGrid from "./ServiceCardGrid";
import { useTranslation } from "react-i18next";
import NewsTabComponent from "./NewsTabComponent";
import ScrollDownIndicator from "./ScrollDownIndicator";

import "../styles/Home.css";
import "../styles/FadeInAnimation.css";

import Aos from "aos";

const HomeComponent = () => {
  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);

  const { t } = useTranslation();

  const news = [
    {
      link_name: t("news_article4_link_name"),
      url: "https://www.isim.ro/ro/transfer-tehnologic/tima",
    },
    {
      link_name: t("news_article3_link_name"),
      url: "https://www.isim.ro/ro/transfer-tehnologic/festival-innocenta",
    },
    {
      link_name: t("news_article2_link_name"),
      url: "https://asr.ro/",
    },
    {
      link_name: t("news_article1_link_name"),
      url: "https://asr.ro/2026/04/27/conferinta-asr-sudura-2026-craiova/",
    },
  ];

  return (
    <div className="home-page-content">
      <div className="home-page-header">
        <div className="home-page-main-image-container fadeIn-animation">
          <NewsTabComponent news={news} />
        </div>
      </div>

      <div className="home-page-text-container home-page-intro">
        <div className="home-page-title-container">
          <h1 className="home-page-title">ASR-CERTPERS</h1>
        </div>
        <div className="home-page-text-container">
          <p className="home-page-text">{t("intro")}</p>
        </div>
        <div className="home-page-scroll-indicator">
          <ScrollDownIndicator
            targetId="home-services"
            className="scroll-down-indicator--light"
          />
        </div>
      </div>

      <div className="service-grid-container" id="home-services">
        <div className="service-grid-title-container">
          <p className="service-grid-title">{t("services_title")}</p>
          <h1 className="service-grid-subtitle">{t("services_subtitle")}</h1>
          <p className="service-grid-text">{t("services_description")}</p>
          <ScrollDownIndicator targetId="home-services-content" />
        </div>
        <div id="home-services-content">
          <ServiceCardGrid />
        </div>
      </div>
    </div>
  );
};

export default HomeComponent;
